<template>
  <div class="finance-list-wrap">
    <el-breadcrumb separator=">" class="bc-nav noborder">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>融资管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>融资管理列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="finance-banner" @click="handleApply" id="auto-0">
      <img src="../../assets/img/finance/pic_banner_sqrz.png" />
    </div>
    <div class="toolbar-wrap">
      <div class="toolbar-item" id="auto-1">
        <span class="demonstration">申请时间</span>
        <el-date-picker
          v-model="tableOptions.startTime"
          type="datetime"
          style="width: 200px"
          placeholder="选择开始时间"
          :clearable="false"
          value-format="timestamp"
          :picker-options="pickerTime"
        >
        </el-date-picker>
        <span>-</span>
        <el-date-picker
          v-model="tableOptions.endTime"
          type="datetime"
          style="width: 200px"
          placeholder="选择结束时间"
          default-time="23:59:59"
          :clearable="false"
          value-format="timestamp"
          :picker-options="pickerTime"
        >
        </el-date-picker>
      </div>
      <div class="toolbar-item" id="auto-2">
        <span class="demonstration">融资状态</span>
        <el-select
          style="width: 150px"
          v-model="tableOptions.applicationStatus"
          placeholder="请选择"
          class="track-elselect"
        >
          <el-option v-for="(item, idx) in applicationStatusList" :label="item.label" :value="item.value" :key="idx">
          </el-option>
        </el-select>
      </div>
      <div class="toolbar-item" id="auto-3">
        <span class="demonstration">放款状态</span>
        <el-select style="width: 150px" v-model="tableOptions.loanStatus" placeholder="请选择" class="track-elselect">
          <el-option v-for="(item, idx) in loanStatusList" :label="item.label" :value="item.value" :key="idx">
          </el-option>
        </el-select>
      </div>
      <div class="toolbar-item">
        <el-button type="primary" @click="handleSearch" id="auto-4">筛选</el-button>
        <el-button class="custom-reset-btn" @click="resetOption" id="auto-5">重置</el-button>
      </div>
    </div>
    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt"> 融资管理列表 </span>
      </div>
      <div class="fr">
        <el-button type="primary" id="auto-6" @click="jumpBank"
          ><span class="bank-enter-icon"></span>网银入口</el-button
        >
      </div>
    </div>
    <div class="table-custom-box" id="auto-7">
      <fe-table
        :tableData="tableData"
        :columns="columns"
        border
        :show-pagination="true"
        :pagination-config="pagination"
        @pagination-current-change="handleCurrentChange"
        @pagination-size-change="handleSizeChange"
      >
        <template #applyTime="{ scope }">
          <span>{{ scope.row.applyTime | stamp2TextDateFull(2) }}</span>
        </template>

        <template #applicationNo="{ scope }">
          <div class="font-blue pointer" @click="showDetail(scope.row)">
            {{ scope.row.applicationNo }}
          </div>
        </template>
        <template #applicationAmount="{ scope }">
          <span>{{ scope.row.applicationAmount | thousands(2) }}</span>
        </template>
        <template #approvalAmount="{ scope }">
          <span>{{ scope.row.approvalAmount | thousands(2) }}</span>
        </template>
        <template #applicationStatusDesc="{ scope }">
          <span
            :class="{ abort: scope.row.applicationStatus == 2, pass: scope.row.applicationStatus == 3 }"
            class="application-status"
            >{{ scope.row.applicationStatusDesc }}</span
          >
        </template>
        <template #loanStatusDesc="{ scope }">
          <span :class="{ active: scope.row.loanStatus == 2 }" class="loan-status">{{ scope.row.loanStatusDesc }}</span>
        </template>

        <template #payableAmount="{ scope }">
          <span>{{ scope.row.payableAmount | thousands(2) }}</span>
        </template>
        <template #repaymentAmount="{ scope }">
          <span>{{ scope.row.repaymentAmount | thousands(2) }}</span>
        </template>
        <template #residueRepaidAmount="{ scope }">
          <span>{{ scope.row.residueRepaidAmount | thousands(2) }}</span>
        </template>
      </fe-table>
    </div>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:7
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import dateLimit from '@/api/dateLimit';
import tableMixin from '@/utils/tableMixin';
import { WUYI } from '@/api/common';
export default {
  mixins: [tableMixin],
  data() {
    return {
      columns: [
        { label: '申请时间', prop: 'applyTime', 'min-width': 100 },
        { label: '融资申请编号', prop: 'applicationNo', 'min-width': 100 },
        { label: '融资产品名称', prop: 'productName', 'min-width': 100 },
        { label: '资金方', prop: 'fundSideName', 'min-width': 100 },
        { label: '融资申请金额', prop: 'applicationAmount', 'min-width': 100 },
        { label: '融资批复金额', prop: 'approvalAmount', 'min-width': 100 },
        { label: '融资状态', prop: 'applicationStatusDesc', 'min-width': 100 },
        { label: '放款状态', prop: 'loanStatusDesc', 'min-width': 100 },
        { label: '应还款金额', prop: 'payableAmount', 'min-width': 100 },
        { label: '已还款金额', prop: 'repaymentAmount', 'min-width': 100 },
        { label: '剩余还款金额', prop: 'residueRepaidAmount', 'min-width': 100 }
      ],
      tableOptions: {
        startTime: null,
        endTime: null,
        applicationStatus: 0,
        loanStatus: 0
      },
      axiosConfig: { url: api.financingApplyQueryPage },
      applicationStatusList: [
        { value: 0, label: '全部' },
        { value: 1, label: '申请中' },
        { value: 2, label: '申请驳回' },
        { value: 3, label: '申请通过' }
      ],
      loanStatusList: [
        { value: 0, label: '全部' },
        { value: 1, label: '未放款' },
        { value: 2, label: '已放款' }
      ],
      pickerTime: {
        disabledDate: time => {
          if (time > dateLimit.currentDayEnd.getTime()) {
            return true;
          }
          return false;
        }
      }
    };
  },
  created() {
    this.handleSearch();
  },
  methods: {
    beforeHandleSearch() {
      if (this.tableOptions.startTime && this.tableOptions.endTime) {
        return WUYI.checkDate(this.tableOptions.startTime, this.tableOptions.endTime);
      }
      return true;
    },
    handleApply() {
      this.$router.push({ path: '/finance/apply' });
    },
    showDetail(row) {
      this.$router.push({ path: `/finance/apply/detail/${row.applicationNo}` });
    },
    jumpBank() {
      window.open(`https://corporatebank.cib.com.cn/firm/main/login.do`);
    }
  }
};
</script>
<style lang="postcss" scoped>
.finance-list-wrap {
  margin: 6px;
  .finance-banner {
    width: 100%;
    margin-bottom: 22px;
    cursor: pointer;
    img {
      width: 100%;
    }
  }
  .bank-enter-icon {
    width: 16px;
    height: 16px;
    display: inline-block;
    background: url('../../assets/img/finance/ico_rz_wyrk.png') no-repeat;
    background-size: 16px 16px;
    vertical-align: text-bottom;
    margin-right: 4px;
  }
  .loan-status {
    padding: 2px 6px;
    border-radius: 2px;
    border: 1px solid #aaaaaa;
    color: #aaa;
    &.active {
      color: #01d28e;
      border: 1px solid #01d28e;
    }
  }
  .application-status {
    position: relative;
    padding-left: 12px;
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 5px;
      width: 6px;
      height: 6px;
      background: #3399ff;
      border-radius: 50%;
    }
    &.pass {
      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 5px;
        width: 6px;
        height: 6px;
        background: #01d28e;
        border-radius: 50%;
      }
    }
    &.abort {
      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 5px;
        width: 6px;
        height: 6px;
        background: #f35856;
        border-radius: 50%;
      }
    }
  }
}
</style>
